<template>
    <div class="create-input-result-dialog">
        <div class="task-detail-wrapper">
            <div class="task-detail-label mb-2"><b>Nội dung task:</b></div>

            <el-input
                type="textarea"
                placeholder="Nhập nội dung công việc..."
                v-model="task_content"
                :rows="8"
                class="task-textarea"
            ></el-input>
        </div>

        <span slot="footer" class="d-flex justify-content-end mt-3">
                <el-button type="info" size="mini" @click="close()">Hủy</el-button>
                <el-button
                    size="mini"
                    type="primary"
                    :disabled="loading"
                    @click="reportResult()"> <i v-if="loading" class="el-icon-loading mr-2"></i>Xác nhận</el-button>
    </span>
    </div>
</template>


<script>

import {mapGetters} from "vuex";
import { UPDATE_CONTENT_TASK } from "@/core/services/store/customer/customer.module";

export default {
    name: 'updateContentTask',
    props: {
        is_show: { type: Boolean, default: () => false },
        task: { type: Object, default: () => {} },
    },
    data () {
        return {
            task_content: '',
            deadline: '',
            loading: false,
        }
    },
    watch: {
        is_show: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.task_content = '';
                    this.loading = false;
                }else {
                    if(this.task.task_content) {
                        this.task_content = this.task.task_content.replace(/<br>/g, '\n');
                    }
                }
            },
        },
    },
    mounted() {

    },

    computed: {
        ...mapGetters(["currentUser", "keyAccount"]),
    },
    methods: {
        reportResult() {
            this.loading = true;
            if(!this.task_content) {
                this.$message({ type: 'warning', message: `Vui lòng nhập nội dung công việc!`, showClose: true });
                this.loading = false;
                return;
            }
            const contentHtml = this.task_content
                ? this.task_content.replace(/\n/g, '<br>')
                : '';

            const payload = {
                task_id: this.task.id,
                content: contentHtml,
            };
            this.$store.dispatch(UPDATE_CONTENT_TASK, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({ type: 'warning', message: `${response.message}`, showClose: true });
                        this.loading = false;
                    } else {
                        this.$message({ type: 'success', message: `${response.message}` ?? 'Báo cáo tiến độ công việc thành công!', showClose: true });
                        this.close();
                        this.task = '';
                        this.task_content = '';
                        this.loading = false;
                    }
                });
        },

        close() {
            this.$emit('close');
        }
    }
}
</script>
